<script>
import { Overlay } from '../../'
import Price from './price.js'

export default {
    name: 'VTLaser',
    props: [
        'data', 'sub'
    ],
    mixins: [Overlay],
    computed: {
        sett() {
            return this.$props.settings
        },
        price_line() {
            return 'priceLine' in this.sett ?
                this.sett.priceLine : true
        },
        risk_reward_ratio() {
            return this.sett.riskRewardRatio || 3
        },
        show_pending_target() {
            return this.sett.showPendingTarget || true
        },
        show_safe_target() {
            return this.sett.showSafeTarget || false
        },
        show_highlight_entry() {
            return this.sett.showSafeTarget || true
        },
        default_font() {
            return '12px ' + this.$props.font.split('px').pop()
        },
        currency_symbol() {
            return this.sett.currency || '₹'
        },
        long_color() {
            return this.sett.longColor || '#63df89'
        },
        short_color() {
            return this.sett.shortColor || '#ffd581'
        },
        long_cover_color() {
            return this.sett.longCoverColor || '#fc7e2f'
        },
        short_cover_color() {
            return this.sett.shortCoverColor || '#ff6bd6'
        },
        label_color() {
            return this.sett.labelColor || '#4BECF9'
        },
        upBarColor() {
            return this.sett.upBarColor || "rgb(38, 166, 154)"
        },
        downBarColor() {
            return this.sett.downBarColor || "rgb(239, 83, 80)"
        },
        pendingTargetColor() {
            return this.sett.pendingTargetColor || "rgb(92, 92, 92)"
        },
        marker_size() {
            return this.sett.markerSize || 5
        },
        show_label() {
            return this.sett.showLabel !== false
        },
        new_font() {
            return this.sett.font || this.default_font
        }
    },
    methods: {
        meta_info() {
            return {
                author: 'Mano',
                version: '1.0.0',
                desc: 'VisualTrading Laser Target',
                preset: {
                    name: 'Laser Target, $smaLength $dcLength $riskRewardRatio',
                    side: 'onchart',
                    settings: {
                        "riskRewardRatio": this.risk_reward_ratio,
                        "showPendingTarget": this.show_pending_target,
                        "showSafeTarget": this.show_safe_target,
                        "showHighlightEntry": this.show_highlight_entry
                    }
                }
            }
        },
        init() {
            this.price = new Price(this)
        },
        draw(ctx) {
            let layout = this.$props.layout
            ctx.lineWidth = 0.5
            ctx.strokeStyle = 'black'

            let fill = "#d9d9d9"
            let fillOpacity = 0.6
            let strokeOpacity = 0.6

            var plotA = []

            var i = 0, j = 0
            var entry = {}
            var clearEntry = true
            var pendingTargetB = 0
            var pendingTargetS = 0

            var lastEntry
            var lastCandle

            var flashSide
            var flashEntry
            var entrySL
            var flashTarget
            var signal = {}
            var blackCandle
            var trendChanged
            var prev
            var starFormed
            var blackCandleFormed
            var fractalHigh
            var fractalLow
            var bigKuchi = 0
            var kuchiEntry

            var data = this.processVTSignals(this.$props.sub.full_data, "minute", {}, true)

            for (var p of data) {

                let now = p
                let open = p.open
                let high = p.high
                let low  = p.low
                let close = p.close
                let nowTrend = now.trend
                let prevTrend = prev ? prev.trend : ""
                let level = 0
                let range = 0

                let candleSize = high - low
                let bodySize
                let upperKuchi
                let lowerKuchi
                let kuchi
                if (open > close) {
                    bodySize = open - close
                    upperKuchi = high - open
                    lowerKuchi = close - low
                }
                else {
                    bodySize = close - open
                    upperKuchi = high - close
                    lowerKuchi = open - low
                }
                if (lowerKuchi > upperKuchi) {
                    kuchi = lowerKuchi
                    if (now.fractalLow > 0) {
                        now.kuchi = kuchi
                    }
                } else {
                    kuchi = upperKuchi
                    if (now.fractalHigh > 0) {
                        now.kuchi = kuchi
                    }
                }

                if (now.kuchi && now.fractalHigh > 0 && now.fractalLow > 0) {
                  if (bigKuchi < now.kuchi) {
                      bigKuchi = now.kuchi
                      kuchiEntry = now
                  }
                }

                if (now.flashSide === "BUY") {
                   level = now.flashEntry - now.flashStoploss
                   range = now.flashTarget - now.flashEntry
                   var t1 = now.flashEntry + level
                   var t2 = now.flashEntry + (level * 2)
                   var mid =  now.flashEntry + (range / 2)
                   //now.flashTarget = now.flashEntry + range
                   now.flashTarget1 = t1
                   now.flashTarget2 = t2
                   now.flashTargetMid = mid
                } else if (now.flashSide === "SELL") {
                   level = now.flashStoploss - now.flashEntry
                   range = now.flashEntry - now.flashTarget
                   var t1 = now.flashEntry - level
                   var t2 = now.flashEntry - (level * 2)
                   var mid =  now.flashEntry - (range / 2)
                   //now.flashTarget = now.flashEntry - range
                   now.flashTarget1 = t1
                   now.flashTarget2 = t2
                   now.flashTargetMid = mid
                }

                if (now.flashSide === "BUY" && (clearEntry || now.flashTradeStart)) {
                    entry = now
                    entry.startIdx = Math.round(layout.t2screen(now.date))
                    entry.endIdx = Math.round(layout.t2screen(now.date))
                    if (pendingTargetB > now.flashTarget)
                    {
                        entry.pendingTarget = pendingTargetB
                    }
                    if (now.open < entry.flashEntry && now.close > entry.flashEntry && now.high < now.flashTarget1) {
                        entry.safeEntry = now.high
                        entry.safeTarget = entry.safeEntry + level
                    }
                    lastEntry = entry
                    pendingTargetB = now.flashTarget
                    plotA[i] = entry
                    clearEntry = false
                } else if (now.flashSide === "SELL" && (clearEntry || now.flashTradeStart)) {
                    entry = now
                    entry.startIdx = Math.round(layout.t2screen(now.date))
                    entry.endIdx = Math.round(layout.t2screen(now.date))
                    if (pendingTargetS < now.flashTarget)
                    {
                        entry.pendingTarget = pendingTargetS
                    }
                    if (now.open > entry.flashEntry && now.close < entry.flashEntry && now.low > now.flashTarget1) {
                        entry.safeEntry = now.low
                        entry.safeTarget = entry.safeEntry - level
                    }
                    pendingTargetS = now.flashTarget
                    plotA[i] = entry
                    lastEntry = entry
                    clearEntry = false
                } else {
                    if (entry.flashSide === "BUY" && !clearEntry && !now.flashTradeStart) {
                        entry.endIdx = Math.round(layout.t2screen(now.date))
                        plotA[i] = entry
                    } else if (entry.flashSide === "SELL" && !clearEntry && !now.flashTradeStart) {
                        entry.endIdx = Math.round(layout.t2screen(now.date))
                        plotA[i] = entry
                    } else if (now.flashTradeStart) {
                        entry = { endIdx: Math.round(layout.t2screen(now.date)) }
                        plotA[i] = entry
                        clearEntry = true
                    } else {
                        entry = { endIdx: Math.round(layout.t2screen(now.date)) }
                        plotA[i] = entry
                        clearEntry = true
                     }
                }
                prev = now
                i++
            }

            let canvasGradient = null
            let canvasClip = false

            if (canvasGradient != null) {
              ctx.fillStyle = canvasGradient(this.$props, ctx)
            } else {
              ctx.fillStyle = this.hexToRGBA(fill, fillOpacity)
            }
            if (canvasClip) {
              ctx.save()
              //canvasClip(ctx, this.$props)
            }
            //ctx.lineWidth = hovering ? hoverStrokeWidth : strokeWidth

            //ctx.setLineDash(getStrokeDasharray(strokeDasharray).split(","))
            const red = "rgba(252, 218, 215, 0.1)"
            const darkGreen = "rgba(18, 124, 63, 0.5)"
            const darkRed = "rgba(252, 218, 215, 0.5)"
            const highlight = "#FFEC30"
            const safeGreen = "#01ab6c"
            const green = "rgba(171, 235, 198, 0.1)"
            const gray = "rgba(245, 245, 245, 0.1)"
            const darkgray = "rgba(212, 212, 212, 0.1)"
            const globalCompositeOperation = ctx.globalCompositeOperation
            const globalAlpha = ctx.globalAlpha

            plotA.forEach(each => {
                const { startIdx, endIdx, flashSide, flashEntry, rsi, flashStoploss, flashTarget, pendingTarget, safeEntry, safeTarget, fractalHigh, fractalLow } = each

                var highlightEntry = false

                if (flashSide) {
                    if (flashSide === "BUY") {
                        if (rsi > 50 && rsi < 95) {
                          highlightEntry = true
                        }
                    } else if (flashSide === "SELL") {
                       if (rsi < 50 && rsi > 5) {
                         highlightEntry = true
                       }
                    }

                    ctx.save()

                    if (this.show_pending_target) {
                        if (pendingTarget > 0) {
                          // Draw Shadow Area
                          ctx.beginPath()
                          ctx.fillStyle = this.hexToRGBA(darkgray, fillOpacity)
                          ctx.strokeStyle = this.hexToRGBA(darkgray, strokeOpacity)
                          ctx.globalAlpha = fillOpacity
                          ctx.globalCompositeOperation = "xor"
                          ctx.rect((startIdx), flashSide === 'BUY' ? layout.$2screen(flashTarget) : layout.$2screen(pendingTarget), (endIdx - startIdx), flashSide === 'BUY' ? layout.$2screen(pendingTarget) - layout.$2screen(flashTarget) : layout.$2screen(flashTarget) - layout.$2screen(pendingTarget))
                          ctx.fill()
                          ctx.stroke()
                          ctx.closePath()
                        }
                    }

                    ctx.globalCompositeOperation = globalCompositeOperation
                    ctx.globalAlpha = globalAlpha


                    if (this.show_safe_target) {
                        if (safeEntry > 0) {
                          // Draw Safe Entry Area
                          ctx.beginPath()
                          ctx.fillStyle = this.hexToRGBA(safeGreen, fillOpacity)
                          ctx.strokeStyle = this.hexToRGBA(red, strokeOpacity)
                          //ctx.globalAlpha = fillOpacity
                          //ctx.globalCompositeOperation = "xor"
                          ctx.rect((startIdx), flashSide === 'BUY' ? layout.$2screen(safeEntry) : layout.$2screen(safeTarget), (endIdx - startIdx), flashSide === 'BUY' ? layout.$2screen(safeTarget) - layout.$2screen(safeEntry) : layout.$2screen(safeEntry) - layout.$2screen(safeTarget))
                          ctx.fill()
                          ctx.stroke()
                          ctx.closePath()
                        }
                    }


                    // Draw Green Area
                    ctx.beginPath()
                    ctx.fillStyle = this.hexToRGBA(green, fillOpacity)
                    ctx.strokeStyle = this.hexToRGBA(green, strokeOpacity)
                    //ctx.globalAlpha = fillOpacity
                    //ctx.globalCompositeOperation = "xor"
                    ctx.rect((startIdx), flashSide === 'BUY' ? layout.$2screen(flashEntry) : layout.$2screen(flashTarget), (endIdx - startIdx), flashSide === 'BUY' ? layout.$2screen(flashTarget) - layout.$2screen(flashEntry) : layout.$2screen(flashEntry) - layout.$2screen(flashTarget))
                    ctx.fill()
                    ctx.stroke()
                    ctx.closePath()

                    // Draw Red Area
                    ctx.beginPath()
                    ctx.fillStyle = this.hexToRGBA(red, fillOpacity)
                    ctx.strokeStyle = this.hexToRGBA(red, strokeOpacity)
                    //ctx.globalCompositeOperation = ""
                    //ctx.globalAlpha = fillOpacity
                    ctx.rect((startIdx), flashSide === 'BUY' ? layout.$2screen(flashStoploss) : layout.$2screen(flashEntry), (endIdx - startIdx), flashSide === 'BUY' ? layout.$2screen(flashEntry) - layout.$2screen(flashStoploss) : layout.$2screen(flashStoploss) - layout.$2screen(flashEntry))
                    ctx.fill()
                    ctx.stroke()
                    ctx.closePath()

                    if (this.show_highlight_entry) {
                        // Highlight Entry Area
                        ctx.beginPath()
                        ctx.strokeStyle = this.hexToRGBA(highlightEntry ? darkRed : red, strokeOpacity)
                        ctx.fillStyle = this.hexToRGBA(highlightEntry ? darkRed : red, fillOpacity)
                        //ctx.globalAlpha = strokeOpacity
                        //ctx.globalCompositeOperation = "xor"
                        ctx.rect((startIdx), flashSide === 'BUY' ? layout.$2screen(flashStoploss) : layout.$2screen(flashEntry), (endIdx - startIdx), flashSide === 'BUY' ? layout.$2screen(flashEntry) - layout.$2screen(flashStoploss) : layout.$2screen(flashStoploss) - layout.$2screen(flashEntry))
                        ctx.fill()
                        ctx.stroke()
                        ctx.closePath()

                        if (highlightEntry && lastEntry.endIdx === endIdx) {
                          // Highlight Entry Area
                          ctx.beginPath()
                          ctx.strokeStyle = this.hexToRGBA(highlight, strokeOpacity)
                          ctx.fillStyle = this.hexToRGBA(highlight, fillOpacity)
                          //ctx.globalAlpha = strokeOpacity
                          //ctx.globalCompositeOperation = ""
                          ctx.rect((endIdx), flashSide === 'BUY' ? layout.$2screen(flashStoploss) : layout.$2screen(flashEntry), (endIdx), flashSide === 'BUY' ? layout.$2screen(flashEntry) - layout.$2screen(flashStoploss) : layout.$2screen(flashStoploss) - layout.$2screen(flashEntry))
                          ctx.fill()
                          ctx.stroke()
                          ctx.closePath()
                        }
                    }

                    //ctx.globalAlpha = 1
                    ctx.restore()
                }
            })

            if (canvasClip) {
              ctx.restore()
            }
            if (this.price_line) this.price.draw(ctx, plotA)
        },

        draw_label(ctx, x, y, labelText) {
            ctx.fillStyle = this.label_color
            ctx.font = this.new_font
            ctx.textAlign = 'center'
            ctx.fillText(labelText, x, y)
        },
        use_for() {
            return ['VTLaser']
        },
        processVTSignals(candles, item, entry, loadTarget) {
            var i = 0, j = 0
            var riskRewardRatio = this.risk_reward_ratio
            var smaLen = this.sma_length
            var dcLen = this.dc_length
            var clearEntry = true
            var pendingTargetB = 0
            var pendingTargetS = 0

            var lastEntry
            var lastCandle

            var sma = 0
            var dcHigh = 0
            var dcLow = 0
            var dcMid = 0
            var flashSide = ""
            var flashEntry = 0
            var entrySL = 0
            var flashTarget = 0
            var signal = {}
            var blackCandle
            var trendChanged
            var prev
            var starFormed
            var blackCandleFormed
            var fractalHigh
            var fractalLow
            var activated = false
            var flashActivated = false
            var cmp = candles && candles.length > 0 ? candles[candles.length - 1][4] : 0
            var data = [];
            var startIndex = 0
            var i = 0

            if (!loadTarget)
                startIndex = candles.length - 30

            for (var p of candles) {
                let tradeTime = p[0]
                let open = p[1]
                let high = p[2]
                let low = p[3]
                let close = p[4]
                var now = { date: tradeTime, open: open, high: high, low: low, close: close }

                if (now.fractalHigh) fractalHigh = now.fractalHigh
                if (now.fractalLow) fractalLow = now.fractalLow

                var candleSize = Math.abs(high - low)
                var bodySize = Math.abs(open - close)

                if (!prev) {
                    prev = now
                    prev.smaColor = ""
                }
                if(now.sma > prev.sma) {
                    now.smaColor = "GREEN"
                } else {
                    now.smaColor = "RED"
                }
                if (candleSize === 0) {
                    blackCandle = false
                    now.blackCandle = blackCandle
                } else {
                    if(bodySize <= (candleSize / 2)) {
                        blackCandle = true
                        now.blackCandle = blackCandle
                    } else {
                        blackCandle = false
                        now.blackCandle = blackCandle
                    }
                }


                var p_open = Number(prev.open)
                var p_high = Number(prev.high)
                var p_low = Number(prev.low)
                var p_close = Number(prev.close)

                if (prev.blackCandle) {
                    var wick1 = 0
                    var wick2 = 0
                    var wickSize = 0
                    if (p_open > p_close) {
                        wick1 = p_high - p_open
                        wick2 = p_close - p_low
                    } else {
                        wick1 = p_high - p_close
                        wick2 = p_open - p_low
                    }
                    if (wick1 > wick2) {
                        wickSize = wick1
                    } else {
                        wickSize = wick2
                    }
                    if (close >= p_high) {
                        var flashTarget = p_high + Number(wickSize * riskRewardRatio)
                        var flashTarget1 = p_high + Number(wickSize * 1)
                        var flashTarget2 = p_high + Number(wickSize * 2)
                        var flashReverseTarget = p_low - Number(wickSize * riskRewardRatio)
                        var flashReverseTarget1 = p_low - Number(wickSize * 1)
                        var flashReverseTarget2 = p_low - Number(wickSize * 2)
                        now.flashTradeStart = true
                        now.flashTrade = true
                        now.flashSide = "BUY"
                        now.flashEntry = Number(p_high)
                        now.flashTarget = Number(flashTarget)
                        now.flashTarget1 = Number(flashTarget1)
                        now.flashTarget2 = Number(flashTarget2)
                        now.flashReverseTarget = Number(flashReverseTarget)
                        now.flashReverseTarget1 = Number(flashReverseTarget1)
                        now.flashReverseTarget2 = Number(flashReverseTarget2)
                        now.flashStoploss = Number(p_low)
                    } else if (close <= p_low) {
                        var flashTarget = p_low - Number(wickSize * riskRewardRatio)
                        var flashTarget1 = p_low - Number(wickSize * 1)
                        var flashTarget2 = p_low - Number(wickSize * 2)
                        var flashReverseTarget = p_high + Number(wickSize * riskRewardRatio)
                        var flashReverseTarget1 = p_high + Number(wickSize * 1)
                        var flashReverseTarget2 = p_high + Number(wickSize * 2)
                        now.flashTrade = true
                        now.flashTradeStart = true
                        now.flashSide = "SELL"
                        now.flashEntry = Number(p_low)
                        now.flashTarget = Number(flashTarget)
                        now.flashTarget1 = Number(flashTarget1)
                        now.flashTarget2 = Number(flashTarget2)
                        now.flashReverseTarget = Number(flashReverseTarget)
                        now.flashReverseTarget1 = Number(flashReverseTarget1)
                        now.flashReverseTarget2 = Number(flashReverseTarget2)
                        now.flashStoploss = Number(p_high)
                    } else {
                        now.flashTrade = false
                        now.flashTradeStart = false
                        now.flashSide = ""
                        now.flashEntry = 0
                        now.flashTarget = 0
                        now.flashTarget1 = 0
                        now.flashTarget2 = 0
                        now.flashReverseTarget = 0
                        now.flashReverseTarget1 = 0
                        now.flashReverseTarget2 = 0
                        now.flashStoploss = 0
                    }
                }

                if (!now.flashTrade) {
                    now.flashTrade = prev.flashTrade
                    now.flashTradeStart = false
                    now.flashSide = prev.flashSide
                    now.flashTarget = prev.flashTarget
                    now.flashTarget1 = prev.flashTarget1
                    now.flashTarget2 = prev.flashTarget2
                    now.flashReverseTarget = prev.flashReverseTarget
                    now.flashReverseTarget1 = prev.flashReverseTarget1
                    now.flashReverseTarget2 = prev.flashReverseTarget2
                }

                if (now.flashTrade) {
                    entry.flashSide = now.flashSide
                    entry.flashEntry = now.flashEntry
                    entry.flashStoploss = now.flashStoploss
                    entry.flashTarget = Number(now.flashTarget)
                    entry.latestFlashTrend = now.date

                    if (entry.flashSide === "BUY") {
                      if ((close < now.flashEntry && close > now.flashStoploss)
                          || (close >= now.flashEntry && close < now.flashTarget)) {
                          flashActivated = true
                      } else {
                          flashActivated = false
                      }
                      if (close >= entry.flashTarget || high >= entry.flashTarget) {
                        flashActivated = false
                      }
                    } else if (entry.flashSide === "SELL") {
                      if ((close > now.flashEntry && close < now.flashStoploss)
                          || (close <= now.flashEntry && close > now.flashTarget)) {
                          flashActivated = true
                      } else {
                          flashActivated = false
                      }
                      if (close <= entry.flashTarget || low <= entry.flashTarget) {
                        flashActivated = false
                      }
                    }
                }
                data[i] = now
                prev = now
                i++
            }

            //this.buyTargets = this.buyTargets.slice(this.buyTargets.length - 3)
            //this.sellTargets = this.sellTargets.slice(this.sellTargets.length - 3)
            entry.activated = activated
            entry.flashActivated = flashActivated
            return data
        },
        hexToRGBA(inputHex, opacity) {
            const hex = inputHex.replace("#", "")
            if (inputHex.indexOf("#") > -1 && (hex.length === 3 || hex.length === 6)) {

                const multiplier = (hex.length === 3) ? 1 : 2

                const r = parseInt(hex.substring(0, 1 * multiplier), 16)
                const g = parseInt(hex.substring(1 * multiplier, 2 * multiplier), 16)
                const b = parseInt(hex.substring(2 * multiplier, 3 * multiplier), 16)

                const result = `rgba(${ r }, ${ g }, ${ b }, ${ opacity })`

                return result
            }
            return inputHex
        }
    }
}
</script>
